import { ContentChildren, Directive, ElementRef, HostListener, Input, OnChanges, QueryList } from '@angular/core';

import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { DIRECTION_LEFT, DIRECTION_RIGHT } from 'hammerjs';

import { SwipeActionsDirective } from './swipe-actions.directive';

@Directive({
    selector: '[msSwipeContainer]',
    standalone: false,
})
export class SwipeContainerDirective implements OnChanges {
    @Input('msSwipeContainer') enabled = true;
    @Input() swipeStartThreshold = 15;
    @Input() swipeEndThreshold = 16;
    @ContentChildren(SwipeActionsDirective, { descendants: true }) items: QueryList<SwipeActionsDirective>;
    @ContentChildren(SwipeActionsDirective, { descendants: true, read: ElementRef }) elementsRef: QueryList<ElementRef<HTMLElement>>;

    ngOnChanges(changes: ISimpleChanges<SwipeContainerDirective>): void {
        if (changes.enabled && changes.enabled.currentValue !== changes.enabled.previousValue && this.items) {
            this.items.forEach((item) => item.close());
        }
    }

    @HostListener('swipe', ['$event'])
    swipe(input: HammerInput): void {
        if (!this.enabled) {
            return;
        }

        input.srcEvent.stopPropagation();
    }

    @HostListener('pan', ['$event'])
    pan(input: HammerInput): void {
        const defaultSwipe = this.swipeStartThreshold > 0;
        const fromRight = input.offsetDirection === DIRECTION_RIGHT;
        const fromLeft = input.offsetDirection === DIRECTION_LEFT;

        if (
            defaultSwipe &&
            (!this.enabled ||
                (!fromRight && !fromLeft) ||
                Math.abs(input.deltaX) < this.swipeStartThreshold ||
                Math.abs(input.deltaY) > Math.abs(input.deltaX))
        ) {
            return;
        }

        input.srcEvent.stopPropagation();

        const target = input.target.closest(`[${SwipeActionsDirective.SWIPE_ATTR}]`);

        const index = this.elementsRef.toArray().findIndex((item) => item.nativeElement === target);
        const items = this.items.toArray();

        if (index === -1) {
            return;
        }

        if (!defaultSwipe && this.swipeEndThreshold) {
            items[index].open(input.deltaX, this.swipeEndThreshold, input.eventType);
        } else if (defaultSwipe && fromRight) {
            items[index].open();
        } else if (defaultSwipe && fromLeft) {
            items[index].close();
        }
    }
}
